<template>
  <div class="rank" style="">
    <div class="rank-header">
      <div class="rank-header-title">大赛排名</div>
      <div
        class="rank-header-content"
        :class="!isShow ? 'rank-header-content-group' : ''"
      >
        <div
          :class="['row', !isShow ? 'row-group' : '']"
          v-for="(item, index) in fields"
          :key="index"
          :style="
            item.property === 'csearch_fund_name' ? 'margin-top: 50px' : ''
          "
        >
          <div class="row-left" v-if="item.property !== 'csearch_scale_group'">
            {{ item.name }}：
          </div>
          <div class="row-left" v-else>
            {{ prods.length ? item.name + "：" : "" }}
          </div>
          <div class="row-right" v-if="item.property === 'csearch_strategy'">
            <div
              :class="[
                'row-right-item',
                searchParmas.csearch_strategy == strate.value ? 'active' : '',
              ]"
              v-for="strate in strategy"
              :key="strate.value"
              @click="onSelectStrategy(strate)"
            >
              <p>{{ strate.label }}</p>
              <p v-if="strate.label2">{{ strate.label2 }}</p>
            </div>
          </div>
          <div
            class="row-right"
            v-if="item.property === 'csearch_scale_group'"
            v-show="prods.length"
          >
            <div
              :class="[
                'row-right-item',
                searchParmas.csearch_scale_group == prodItem.value
                  ? 'active'
                  : '',
              ]"
              v-for="prodItem in prods"
              :key="prodItem.value"
              @click="onSelectProd(prodItem)"
            >
              <p v-for="(label, idx) in prodItem.label" :key="idx">
                {{ label }}
              </p>
            </div>
          </div>
          <div
            class="row-right-container"
            v-if="item.property === 'csearch_rank_range'"
          >
            <div class="row-right">
              <div
                :class="[
                  'row-right-item',
                  searchParmas.csearch_rank_range == rang.value ? 'active' : '',
                ]"
                v-for="rang in ranges"
                :key="rang.value"
                @click="onSelectRang(rang)"
              >
                <p>{{ rang.label }}</p>
              </div>
            </div>
            <div class="row-right-sub">
              <div :class="['row-right-sub-item', rangesDateActive == subIndex ? 'active' : '']" v-for="(subItem, subIndex) in rangesDate" :key="subIndex" @click="onSelectRangDate(subIndex, subItem)">
                <p>{{ subItem.label }}</p>
              </div>
            </div>
          </div>
          <!-- 页面搜索 -->
          <div class="row-right" v-if="item.property === 'csearch_fund_name'">
            <div class="input-item">
              <input
                placeholder="请输入基金名称/所属机构关键字"
                v-model="searchParmas.csearch_fund_name"
              />
              <img src="../assets/img/search.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 页面表格数据 -->
    <div class="rank-content">
      <p class="tips">
        请前往<span>基金大师</span>查看本机构的参赛信息和排名数据，还需了解更多排名详细内容请联系大赛组委会
      </p>
      <div class="rank-content-table">
        <table border="0">
          <tr style="border-bottom: 1px solid #3945a8;">
            <td style="text-align: center">排名</td>
            <td style="text-align: center">参赛产品</td>
            <td style="text-align: center">所属机构</td>
          </tr>
          <tr class="empty" v-if="!tableData.length">
            <td colspan="11">
              <img src="../assets/img/rank-empty.png" />
              <p>没有符合条件的产品或产品未上榜</p>
            </td>
          </tr>
          <tr style="border-bottom: 1px solid #3945a8;" :class="[(index % 2 == 0)? 'even': '']" v-for="(item, index) in tableData" :key="index" v-else>
            <!-- <td style="text-align: center; padding: 8px 27px;" v-if="item.ranking == 1">
              <img src="../assets/img/rank1.png" style="vertical-align: middle;" alt="">
            </td>
            <td style="text-align: center; padding: 8px 27px;" v-else-if="item.ranking == 2">
              <img src="../assets/img/rank2.png" style="vertical-align: middle;" alt="">
            </td>
            <td style="text-align: center; padding: 8px 27px;" v-else-if="item.ranking == 3">
              <img src="../assets/img/rank3.png" style="vertical-align: middle;" alt="">
            </td>
            <td style="text-align: center;" v-else>{{ item.ranking }}</td>
            <td style="text-align: center;">{{ item.productName || "暂无" }}</td>
            <td style="text-align: center;">{{ item.companyName || "暂无" }}</td> -->
            <td style="text-align: center; padding: 8px 27px;" v-if="item.rank_score == 1">
              <img src="../assets/img/rank1.png" style="vertical-align: middle;" alt="">
            </td>
            <td style="text-align: center; padding: 8px 27px;" v-else-if="item.rank_score == 2">
              <img src="../assets/img/rank2.png" style="vertical-align: middle;" alt="">
            </td>
            <td style="text-align: center; padding: 8px 27px;" v-else-if="item.rank_score == 3">
              <img src="../assets/img/rank3.png" style="vertical-align: middle;" alt="">
            </td>
            <td style="text-align: center;" v-else>{{ item.rank_score }}</td>
            <td style="text-align: center;">{{ item.fund_name_display || "暂无" }}</td>
            <td style="text-align: center;">{{ item.company_name || "暂无" }}</td>
          </tr>
        </table>
        <div class="align-center" style="margin-top: 45px">
          <!---->
          <pageination
            ref="pageination"
            :total="count" 
            :current-page="searchParmas.page" 
            :display="searchParmas.rows" 
            @pagechange="pageCallback"
            v-if="tableData.length"
          />
          <!---->
        </div>
      </div>
      <div class="rank-footer">
        <p>备注说明</p>
        <p>·过了报名有效期参赛的产品除了不参与当月排名，其他榜单均参与</p>
        <p>·数据报送不全的产品不参与排名</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { dataResult } from "@/lib/data.js";
import pageination from '@/components/pagination'

export function debounce(func, delay) {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export default {
  components: {
    pageination
  },
  data() {
    return {
      fields: [],
      strategy: [], // 策略类型
      prods: [],
      ranges: [], // 排名周期
      rangesDate: [], // 排名周期时间
      rangesDateActive: 0,
      isShow: true,
      searchParmas: {
        match_code: "shenwanjm",
        csearch_strategy: 1,
        csearch_scale_group: 2,
        csearch_rank_range: "1m",
        csearch_end_date: "",
        csearch_fund_name: "",
        page: 1,
        rows: 10,
      },
      tableData: [],
      count: 0,
      total_page: 0, // 总的页数
    };
  },
  created() {
    this.init();
    this.onKeyupSearch();
  },
  methods: {
    init() {
      /*
        axios
          .get(
            "https://activity.simuwang.com/backend/api/competition/getRankSearchFields",
            {
              params: {
                match_code: "shenwanjm",
              },
            }
          )
          .then((resp) => {
            if (resp.status == 200) {
              var result = resp.data.data;
              console.log(result);
              this.fields = result.fields
                .filter((item) => item.property !== "csearch_end_date")
                .map((item) => {
                  if (item.property === "csearch_scale_group") {
                    item.name = "产品分组";
                  }
                  return item;
                });
              // 策略类型
              var strategy = result.option_definition.csearch_strategy;
              this.strategy =
                strategy.length &&
                strategy.map((item) => {
                  if (item.label.indexOf("&") > -1) {
                    item.label = item.label.split("&");
                  } else {
                    item.label = [item.label];
                  }
                  return item;
                });
              this.prods = this.strategy[0]["children"].length && this.arraySplit(this.strategy[0]["children"]);
              this.ranges = result.option_definition.csearch_rank_range; // 排名周期
              this.getTableList(this.searchParmas);
            }
          });
      */
      var result = dataResult;
      console.log(result);
      this.fields = result.fields
        .filter((item) => item.property !== "csearch_end_date")
        .map((item) => {
          if (item.property === "csearch_scale_group") {
            item.name = "产品分组";
          }
          return item;
        });
      // 策略类型
      var strategy = result.option_definition.csearch_strategy;
      this.strategy =
        strategy.length &&
        strategy.map((item) => {
          if (item.label.indexOf("&") > -1) {
            var labelArr = item.label.split("&");
            item.label = labelArr[0];
            item.label2 = labelArr[1];
          }
          return item;
        });
      this.prods =
        this.strategy[0]["children"].length &&
        this.arraySplit(this.strategy[0]["children"]);
      this.ranges = result.option_definition.csearch_rank_range; // 排名周期
      this.rangesDate = this.ranges[0]['children']; // 排名周期时间
      if ( this.rangesDate && this.rangesDate.length ) {
        this.searchParmas.csearch_end_date = this.rangesDate[0]['value']
      } else {
        this.searchParmas.csearch_end_date = ""
      }
      this.getTableList(this.searchParmas);
    },
    arraySplit(arr) {
      if (!Array.isArray(arr)) return arr;
      arr.map((item) => {
        if (item.label.indexOf("(") > -1) {
          item.label = item.label.split("(");
          item.label[1] = "(" + item.label[1];
        }
        return item;
      });
      return arr;
    },
    // 策略类型
    onSelectStrategy(item) {
      this.searchParmas.csearch_strategy = item.value
      if ( this.tableData.length ) {
        this.$refs.pageination.setCurrent(1)
        this.$refs.pageination.value = 1
      }
      this.searchParmas.page = 1
      if (item.children && item.children.length) {
        this.prods = item.children.length && this.arraySplit(item.children);
        this.isShow = true;
        // this.searchParmas.csearch_scale_group = this.prods[0].value
      } else {
        this.prods = [];
        this.isShow = false;
        this.searchParmas.csearch_scale_group = "";
      }
      this.getTableList(this.searchParmas);
    },
    // 产品分组
    onSelectProd(item) {
      if ( this.tableData.length ) { 
        this.$refs.pageination.setCurrent(1)
        this.$refs.pageination.value = 1
      }
      this.searchParmas.page = 1
      this.searchParmas.csearch_scale_group = item.value;
      this.getTableList(this.searchParmas);
    },
    // 排名周期
    onSelectRang(item) {
      this.rangesDateActive = 0
      this.searchParmas.csearch_rank_range = item.value
      if ( item.children && item.children.length ) {
        this.rangesDate = item.children
        this.searchParmas.csearch_end_date = this.rangesDate[0]['value']
      } else {
        this.rangesDate = []
        this.searchParmas.csearch_end_date = ""
      }
      console.log(this.searchParmas)
      this.getTableList(this.searchParmas);
    },
    // 选择当前时间
    onSelectRangDate(index, item) {
      this.rangesDateActive = index
      this.searchParmas.csearch_end_date = item.value
      this.getTableList(this.searchParmas);
    },
    // 输入搜索
    onKeyupSearch() {
      this.$watch(
        "searchParmas.csearch_fund_name",
        debounce(() => {
          this.getTableList(this.searchParmas);
        }, 1000)
      );
    },
    // 获取表格数据
    getTableList(params) {
      var searchParams = {
        strategyType: "",
        group: "",
        date: "",
        type: "",
        keywork: "",
        pageIndex: 0,
        pageSize: 0,
      };
      var year = new Date().getFullYear();
      var month =
        Number(new Date().getMonth()) + 1 >= 10
          ? Number(new Date().getMonth()) + 1
          : "0" + (Number(new Date().getMonth()) + 1);
      searchParams.date = year + "-" + month;
      this.strategy.forEach((item) => {
        if (item.value == params.csearch_strategy) {
          searchParams.strategyType = item.label.toString();
          if (params.csearch_strategy == 2) {
            searchParams.strategyType = "相对价值&混合策略组";
          }
        }
        if (item.children && item.children.length) {
          item.children.forEach((child) => {
            if (
              item.value == params.csearch_strategy &&
              child.value == params.csearch_scale_group
            ) {
              searchParams.group = child.label[0];
            }
          });
        }
      });
      if(this.ranges && this.ranges.length) {
        var result = this.ranges.filter((item) => item.value == params.csearch_rank_range);
        searchParams.type = result[0]["label"];
        searchParams.keywork = params.csearch_fund_name;
        searchParams.pageIndex = params.page;
        searchParams.pageSize = params.rows;
        // http://10.222.21.157:6009
        // axios.post("http://10.222.21.157:6009/api/SWHY/querymatchranking",searchParams)
        //   .then((resp) => {
        //     if (resp.status == 200) {
        //       if( resp.data.total <= 30 ) {
        //         this.count = resp.data.total
        //       } else {
        //         this.count
        //       }
        //       this.total_page = this.pageTotal(this.count, 10)
        //       var resultData = resp.data.datas
        //       this.tableData = []
        //       if( resultData && resultData.length ) {
        //         for( var i = 0; i < resultData.length; i++ ){
        //           resultData[i]['productName_display'] = ''
        //           if( resultData[i]['productName'] ) {
        //             resultData[i]['productName_display'] = this.desensitization(resultData[i]['productName'], 2, 4);
        //           }
        //         }
        //         this.tableData = resultData
        //       }
        //     }
        //   });
        
        axios.get("https://activity.simuwang.com/backend/api/competition/commonRankList", {
          params
        })
          .then((resp) => {
            console.log(resp)
            if( resp.data.data.pager.count <= 30 ) {
              this.count = resp.data.data.pager.count
            } else {
              this.count = 30
            }
            this.total_page = this.pageTotal(this.count, 10)
            this.tableData = resp.data.data.data
          });
      }
    },
    pageCallback(page) {
      this.searchParmas.page = page
      this.getTableList(this.searchParmas)
    },
    // 计算总页数
    pageTotal(rowCount, pageSize) {
      if (rowCount == null || rowCount == '') {
        return 0;
      } else {
        if (pageSize != 0 && rowCount % pageSize == 0) {
          return parseInt(rowCount / pageSize);
        }
        if (pageSize != 0 && rowCount % pageSize != 0) {
          return parseInt(rowCount / pageSize) + 1;
        }
      }
    },
    // 脱敏设置
    desensitization(str,beginLen,endLen) {
      var len = str.length;
      var firstStr = str.substr(0,beginLen);
      var lastStr = str.substr(endLen);
      var middleStr = str.substring(beginLen, len-Math.abs(endLen)).replace(/[\s\S]/ig, '*');
      var tempStr = firstStr + middleStr + lastStr;
      return tempStr;
    }

  }
};
</script>

<style lang="less" scoped>
.rank {
  width: 1200px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 49px;
  table {
    width: 100%;
    margin-top: 21px;
    color: #fff;
    font-size: 16px;
    border-collapse: collapse;
    tr.even {
      background: rgba(4, 11, 133, 0.6) !important;
    }
    td {
      position: relative;
      border: 1px solid #3945a8;
      padding: 15px 27px;
      p {
        line-height: 30px;
      }
    }
    .bg-color {
      background-color: #3945a8;
    }
    .bg-color2 {
      background-color: rgba(61, 73, 172, 0.4);
    }
    .f-c-c {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
  }
  .align-center {
    text-align: center;
    .pageination .pagination_page {
      font-size: 18px;
      display: inline-block;
      padding: 8px 10px;
      line-height: 20px;
      margin: 0 5px;
      border-radius: 2px;
      cursor: pointer;
      background-color: #3945A8;
      border: none;
    }
  }
}
.rank-header {
  width: 100%;
  padding-top: 25px;
  .rank-header-title {
    height: 61px;
    line-height: 61px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    background: url("../assets/img/title-bg.png") no-repeat center / 100% 100%;
  }
  .rank-header-content {
    margin-top: -30px;
    padding: 60px 30px;
    background: url("../assets/img/box-bottom-bg.png") no-repeat bottom / 100%
      100%;
    &-group {
      padding-top: 80px;
    }
    .row {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-top: 20px;
      color: #fff;
      font-size: 16px;
      &.row-group {
        margin: 0;
      }
    }
    .row-left {
      width: 102px;
      margin-right: 28px;
      padding-top: 20px;
      text-align: right;
    }
    .row-right,
    .row-right-sub {
      width: 1010px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      .active {
        background: #b38a1f;
        border-color: #b38a1f;
        // font-weight: bold;
      }
      .input-item {
        display: inline-block;
        position: relative;
        input {
          width: 430px;
          height: 50px;
          border: 1px solid #d7dae2;
          border-radius: 2px;
          font-size: 18px;
          padding-left: 20px;
          padding-right: 40px;
          background: #fff;
          color: #000;
          &:focus-visible {
            // outline: -webkit-focus-ring-color auto 1px;
            outline-color: -webkit-focus-ring-color;
            outline-style: auto;
            outline-width: 1px;
          }
        }
        img {
          position: absolute;
          top: 13px;
          right: 15px;
          width: 22px;
        }
      }
    }
    .row-right-item,
    .row-right-sub-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      width: 210px;
      height: 60px;
      border: 1px solid #6c77cb;
      border-radius: 2px;
      line-height: 24px;
      margin-right: 10px;
      cursor: pointer;
    }
    .row-right-container {
      width: 1010px;
    }
    .row-right-sub {
      padding-top: 10px;
      .row-right-sub-item {
        width: 150px;
        height: 40px;
        margin-top: 10px;
      }
    }
  }
}
.rank-content {
  padding-top: 30px;
  .tips {
    font-size: 16px;
    color: #fff;
    span {
      color: #eabc4c;
      padding: 0 4px;
      cursor: pointer;
    }
  }
  .rank-content-table table {
    background: #6c77cb;
    margin-top: 15px;
    tr td {
      border: none;
      border-right: 1px solid #040b85;
      &:nth-last-child(1) {
        border: none;
      }
      img {
        width: 32px;
      }
    }
    .empty {
      width: 100%;
      height: 599px;
      background: rgba(4, 10, 133, 0.6);
      text-align: center;
      img {
        width: 240px;
        height: 157px;
      }
      p {
        margin-top: 22px;
        font-size: 16px;
        color: #fff;
      }
    }
  }
  .rank-footer {
    padding-top: 45px;
    font-size: 16px;
    color: #fff;
    line-height: 30px;
  }
}
</style>

